/* ============================================================================
   TESCOMA — Cart drawer (reescrito 04/11/2026)

   Sustituye por completo al ShopifyCartDrawer de main.min.js, que tenía:
     1. GET a /cart/change?line=N  -> Shopify responde 302 y descarga la página
        /cart entera en cada clic (lento, varios cientos de KB).
     2. Doble disparo del evento "SCE:mutate" (uno desde el interceptor de
        fetch y otro desde el .then() de addCart) -> dos renders simultáneos
        del drawer compitiendo entre sí -> HTML desfasado y listeners perdidos.
     3. Sin cola de peticiones: dos clics seguidos lanzaban mutaciones
        solapadas sobre el mismo "line", con respuestas fuera de orden.
     4. La clase .loading pinta una capa a pantalla completa (z-index 999)
        sobre el drawer, incluido el botón FINALIZAR COMPRA. Con la petición
        lenta del punto 1 y los renders del punto 2 esa capa se quedaba
        encima: el carrito parecía bloqueado.
     5. Listeners reenganchados en cada render (addEventsCart + rebindButton)
        que se acumulaban o se perdían según qué render ganase la carrera.
     6. alert() nativo en caso de error (modal bloqueante en móvil).

   Esta versión:
     - Usa la Cart AJAX API (POST /cart/change.js) con item key, no line.
     - Pide el HTML de la sección en la MISMA petición (Section Rendering API).
     - Serializa las mutaciones en una cola y descarta respuestas obsoletas.
     - Delegación de eventos a nivel de contenedor: cero listeners duplicados.
     - Estado de carga por línea; el botón de checkout nunca queda tapado.
     - Errores en línea, sin alert().
   ========================================================================= */
(function () {
  'use strict';

  var SECTION = 'cart-drawer';
  var SEL = {
    container: '.cart-drawer--container',
    wrapper: '.cart-drawer--wrapper',
    item: '.cart-list .item',
    form: '.cart--box',
    underCart: '.under-cart'
  };

  var root = function () { return window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/'; };
  var container = null;
  var busy = 0;          // mutaciones en vuelo
  var token = 0;         // para descartar respuestas obsoletas
  var queue = Promise.resolve();

  /* ---------------------------------------------------------------- utils */

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function getContainer() {
    if (!container || !container.isConnected) container = $(SEL.container);
    return container;
  }

  function open() {
    var c = getContainer();
    if (!c) return;
    c.classList.add('open');
    c.setAttribute('aria-hidden', 'false');
    document.addEventListener('keydown', onKeydown);
  }

  function close() {
    var c = getContainer();
    if (!c) return;
    c.classList.remove('open');
    c.setAttribute('aria-hidden', 'true');
    document.removeEventListener('keydown', onKeydown);
  }

  function onKeydown(e) {
    if (e.key === 'Escape' || e.keyCode === 27) close();
  }

  function updatePaddingBottom() {
    var c = getContainer();
    if (!c) return;
    var under = $(SEL.underCart, c);
    c.style.setProperty('--padding-bottom', under ? under.offsetHeight + 'px' : '133px');
  }

  function showError(msg) {
    var c = getContainer();
    if (!c) return;
    // Se cuelga del contenedor (no del wrapper), que es lo único que NO se
    // sustituye al repintar la sección: así el aviso no desaparece solo.
    var box = $(':scope > .cart-drawer__error', c);
    if (!box) {
      box = document.createElement('div');
      box.className = 'cart-drawer__error';
      box.setAttribute('role', 'alert');
      c.appendChild(box);
    }
    box.textContent = msg;
    box.classList.add('is-visible');
    clearTimeout(showError._t);
    showError._t = setTimeout(function () { box.classList.remove('is-visible'); }, 5000);
  }

  function clearError() {
    var box = $('.cart-drawer__error', getContainer() || document);
    if (box) box.classList.remove('is-visible');
  }

  /* ------------------------------------------------------------- rendering */

  function renderSection(html) {
    var c = getContainer();
    if (!c || !html) return;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var fresh = parsed.querySelector(SEL.wrapper);
    var live = $(SEL.wrapper, c);
    if (!fresh || !live) return;

    live.replaceWith(fresh);
    container = $(SEL.container) || c;

    // Carrusel de recomendaciones (función global de main.min.js).
    try {
      if (typeof eventoCustomPorductCarousel === 'function') {
        var tracks = $$('.cart-recommendations .custom-carousel-track', getContainer());
        if (tracks.length) {
          if ('requestIdleCallback' in window) requestIdleCallback(function () { eventoCustomPorductCarousel(tracks); });
          else setTimeout(function () { eventoCustomPorductCarousel(tracks); }, 200);
        }
      }
    } catch (err) { /* el carrusel no debe romper el carrito */ }

    updatePaddingBottom();
    updateCartCount();
  }

  function updateCartCount() {
    // Mantiene sincronizado cualquier contador del header si existe.
    var sup = $('.cart--header .title-cart sup', getContainer() || document);
    var badge = $('.open-cart .cart-count');
    if (badge && sup) badge.textContent = sup.textContent.trim();
  }

  // Refresco completo pidiendo sólo la sección (para add/clear externos).
  function refresh(shouldOpen) {
    var mine = ++token;
    return fetch(root() + '?sections=' + SECTION, {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (mine !== token) return;            // respuesta obsoleta
        renderSection(data[SECTION]);
        if (shouldOpen) requestAnimationFrame(open);
      })
      .catch(function (err) { console.error('[cart-drawer] refresh:', err); });
  }

  /* --------------------------------------------------------------- mutación */

  function setItemBusy(li, state) {
    if (!li) return;
    li.classList.toggle('is-updating', !!state);
    li.setAttribute('aria-busy', state ? 'true' : 'false');
  }

  function setBusy(state) {
    busy += state ? 1 : -1;
    if (busy < 0) busy = 0;
    var c = getContainer();
    if (c) c.classList.toggle('is-busy', busy > 0);
  }

  /* Cantidades pendientes de enviar, por item key. Permiten pulsar "+"
     varias veces seguidas sin perder ningún toque: la interfaz responde al
     instante y al servidor sólo viaja el valor final. */
  var pending = Object.create(null);
  var timers = Object.create(null);

  function hasPending() {
    for (var k in pending) return true;
    return false;
  }

  function scheduleChange(key, realKey, line, target, li, immediate) {
    clearError();
    pending[key] = { quantity: target, line: line, key: realKey };

    // UI optimista: la cantidad cambia en pantalla sin esperar a la red.
    var input = li && li.querySelector('.quantity input');
    if (input) input.value = target;
    setItemBusy(li, true);

    clearTimeout(timers[key]);
    if (immediate) flush(key, li);
    else timers[key] = setTimeout(function () { flush(key, li); }, 250);
  }

  function flush(key, li) {
    var p = pending[key];
    if (!p) return;
    delete pending[key];
    changeLine({ key: p.key, line: p.line, quantity: p.quantity }, li);
  }

  /**
   * Cambia la cantidad de una línea. Serializado: nunca hay dos mutaciones
   * del carrito en vuelo a la vez, así que Shopify no devuelve estados
   * intermedios ni 422 por carreras.
   */
  function changeLine(payload, li) {
    setBusy(true);

    queue = queue.then(function () {
      var mine = ++token;
      var body = {
        quantity: payload.quantity,
        sections: SECTION,
        sections_url: window.location.pathname
      };
      if (payload.key) body.id = payload.key;
      else body.line = payload.line;

      return fetch(root() + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        credentials: 'same-origin',
        body: JSON.stringify(body)
      })
        .then(function (res) {
          return res.json().then(function (data) { return { ok: res.ok, data: data }; });
        })
        .then(function (r) {
          if (!r.ok || r.data.status === 422 || r.data.errors) {
            showError(r.data.description || r.data.message || 'No se ha podido actualizar el carrito.');
            return refresh(false);
          }
          if (mine !== token) return;
          // Si el usuario ha seguido pulsando, no repintamos todavía: el
          // último flush se encargará, y así no se "revierte" en pantalla
          // una cantidad que el usuario ya ha vuelto a cambiar.
          if (hasPending()) return;
          if (r.data.sections && r.data.sections[SECTION]) renderSection(r.data.sections[SECTION]);
          else return refresh(false);

          document.dispatchEvent(new CustomEvent('tescoma:cart:updated', { detail: r.data }));
          // Compatibilidad con el resto del tema.
          window.dispatchEvent(new CustomEvent('SCE:mutate', { detail: r.data }));
          window.dispatchEvent(new CustomEvent('SCE:change', { detail: r.data }));
        })
        .catch(function (err) {
          console.error('[cart-drawer] change:', err);
          showError('Error de conexión. Vuelve a intentarlo.');
          return refresh(false);
        })
        .finally(function () {
          setBusy(false);
          setItemBusy(li, false);
        });
    }).catch(function (err) {
      // La cola nunca debe quedarse en estado rechazado: si lo hiciera,
      // todos los clics posteriores dejarían de funcionar (eso es
      // exactamente el "se bloquea" que reportaban los clientes).
      console.error('[cart-drawer] queue:', err);
      setBusy(false);
      setItemBusy(li, false);
    });

    return queue;
  }

  /* ------------------------------------------------------- eventos (deleg.) */

  function parseFromHref(a) {
    // Fallback si el markup no trae data-key / data-quantity.
    try {
      var u = new URL(a.getAttribute('href'), window.location.origin);
      return {
        line: parseInt(u.searchParams.get('line'), 10),
        quantity: parseInt(u.searchParams.get('quantity'), 10)
      };
    } catch (e) { return null; }
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    // Abrir / cerrar
    if (t.closest('.open-cart')) { e.preventDefault(); open(); return; }
    if (t.closest('.close-cart, .close-cart-button')) { e.preventDefault(); close(); return; }

    var c = getContainer();
    if (!c || !c.contains(t)) return;

    var ctrl = t.closest('.quantity .minus, .quantity .plus, .quantity-and-remove .remove');
    if (!ctrl) return;

    e.preventDefault();
    e.stopPropagation();

    var li = ctrl.closest(SEL.item);
    var key = ctrl.getAttribute('data-key') || (li && li.getAttribute('data-key'));
    var fromHref = parseFromHref(ctrl);
    var line = (li && parseInt(li.getAttribute('data-line'), 10)) || (fromHref && fromHref.line);
    if (!key && !line) return;

    var isRemove = ctrl.classList.contains('remove');
    var target;

    if (isRemove) {
      target = 0;
    } else {
      // Partimos de lo que se ve en pantalla (ya incluye los toques
      // anteriores aún no enviados), no de lo que había en el último render.
      var input = li && li.querySelector('.quantity input');
      var current = input ? parseInt(input.value, 10) : NaN;
      if (isNaN(current)) {
        var attr = parseInt(ctrl.getAttribute('data-quantity'), 10);
        if (isNaN(attr)) return;
        target = attr;
      } else {
        target = current + (ctrl.classList.contains('plus') ? 1 : -1);
      }
      if (target < 0) target = 0;
    }

    scheduleChange(key || ('line:' + line), key, line, target, li, isRemove);
  }, false);

  // El formulario de checkout espera a que termine cualquier actualización
  // pendiente, para no enviar cantidades desfasadas ni perder el clic.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches(SEL.form)) return;
    var c = getContainer();
    if (!c || !c.contains(form)) return;
    if (busy === 0) return;                 // camino normal: no interferimos

    e.preventDefault();
    var btn = form.querySelector('[name="checkout"]');
    if (btn) btn.classList.add('loading');
    queue.then(function () {
      // El drawer se ha vuelto a renderizar: usamos el formulario vigente.
      var live = $(SEL.form, getContainer());
      if (live) live.submit();
    });
  }, true);

  /* ---------------------------------- interceptor sólo para add/clear ajeno */

  // Otras partes del tema (product-form.min.js, window.addToCart,
  // setupAjaxAddToCartForms) añaden al carrito con fetch a /cart/add.js y
  // esperan que el drawer se abra. Interceptamos SÓLO add y clear: nuestras
  // propias llamadas (change.js) no pasan por aquí, así que no hay doble
  // render como en la versión anterior.
  var WATCH = /\/cart\/(add|clear)(\.js)?(\?|$)/;

  function isWatched(url) {
    if (!url) return false;
    try { return WATCH.test(String(url).split('#')[0]); } catch (e) { return false; }
  }

  var nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function') {
    window.fetch = function () {
      var url = arguments[0];
      if (url && typeof url === 'object' && url.url) url = url.url;
      var p = nativeFetch.apply(this, arguments);
      if (isWatched(url)) {
        p.then(function (res) {
          if (res && res.ok) refresh(true);
        }).catch(function () { /* el error lo gestiona quien llamó */ });
      }
      return p;
    };
  }

  var nativeOpen = window.XMLHttpRequest && window.XMLHttpRequest.prototype.open;
  if (nativeOpen) {
    window.XMLHttpRequest.prototype.open = function (method, url) {
      if (isWatched(url)) {
        this.addEventListener('load', function () {
          if (this.status >= 200 && this.status < 300) refresh(true);
        });
      }
      return nativeOpen.apply(this, arguments);
    };
  }

  // Eventos propios del tema que ya existían.
  document.addEventListener('cascade:cart:item-added', function () { refresh(true); });
  document.addEventListener('product-form:added', function () { refresh(true); });

  /* --------------------------------------------------------------- arranque */

  function init() {
    container = $(SEL.container);
    if (!container) return;
    container.setAttribute('aria-hidden', container.classList.contains('open') ? 'false' : 'true');
    updatePaddingBottom();
    window.addEventListener('resize', updatePaddingBottom);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.TescomaCartDrawer = { open: open, close: close, refresh: refresh };
})();
